import * as React from 'react';

import ArticleEntityCard from 'bundles/unified-seo-content-common/components/entity-cards/ArticleEntityCard';
import EntityCardPlaceholder from 'bundles/unified-seo-content-common/components/entity-cards/EntityCardPlaceholder';
import { ENTITY_TYPES } from 'bundles/unified-seo-content-common/constants';
import useEntityCardData from 'bundles/unified-seo-content-common/hooks/useEntityCardData';
import useEntityCardLink from 'bundles/unified-seo-content-common/hooks/useEntityCardLink';
import { getEntityTypeLabel } from 'bundles/unified-seo-content-common/utils';
import { getDegreeQueryConfig } from 'bundles/unified-seo-content-common/utils/entityCardDataQueryUtils';

import _t from 'i18n!nls/articles';

type InputProps = {
  slug: string;
};

type Props = InputProps;

const DegreeEntityCard = ({ slug }: Props) => {
  const { data: degreeMetadata, loading } = useEntityCardData(getDegreeQueryConfig(slug));
  const cardLink = useEntityCardLink({ entityType: ENTITY_TYPES.degree, slug });

  if (loading) {
    return <EntityCardPlaceholder />;
  }

  if (!degreeMetadata || !degreeMetadata.name || !degreeMetadata.imageUrl || !degreeMetadata?.partners?.[0]?.name) {
    return null;
  }

  const articleEntityCardProps = {
    title: degreeMetadata?.name,
    subtitle: degreeMetadata?.partners?.[0]?.name,
    label: getEntityTypeLabel(ENTITY_TYPES.degree),
    imageSrc: degreeMetadata?.imageUrl,
    imageAlt: 'Entity Photo',
    ctaHref: cardLink,
    ctaLabel: _t('Learn More'),
  };

  return <ArticleEntityCard {...articleEntityCardProps} />;
};

export default DegreeEntityCard;
